// @flow

// make sure the resource prefixes here always match what can be handled by AccessControlSelect
export const resourceTypeOnlyMatch: RegExp = /^(srv|grp|lba|dbs|int|cli)$/;
export const resourceIdFullMatch: RegExp = /^(srv|grp|lba|dbs|int|cli)-[a-z0-9]{5}$/;
export const resourceTypeMatch: RegExp = /^(srv|grp|lba|dbs|int|cli)-/;